import * as React from "react";
import { Nav, Row, Col, Container } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import { IAuthentication } from "../store/authentication";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { IApplicationState } from "../store";
import * as instituteActions from "../store/institute/actions";
import { IInstitute } from "../store/institute";
import { IFailedUploadFetchRequest } from "../store/failedupload";
import * as failedUploadActions from "../store/failedupload/actions";
import FailedUploadList from "../components/FailedUploadList";

interface IPropertiesFromState {
  authentication?: IAuthentication;
  institutes: IInstitute[];
}

interface IPropertiesFromDispatch {
  instituteFetchRequest: typeof instituteActions.fetchRequest;
  fetchFailedUploadsRequest: typeof failedUploadActions.fetchRequest;
}

interface IFailedUploadPageState {
  selectedPage: string;
  instituteId: number;
}

class FailedUploadPage extends React.Component<IPropertiesFromState & IPropertiesFromDispatch & WithTranslation, IFailedUploadPageState> {

  public readonly state: IFailedUploadPageState = {
    selectedPage: "",
    instituteId: -1,
  }

  public componentDidMount() {
    if (this.props.authentication == null) {
      return;
    }
    // if authenticated user is the sysadmin => load institutes
    // otherwise: load the failed uploads of the institute which belongs to the user
    if (this.props.authentication.sysadmin) {
      this.props.instituteFetchRequest(false);
    } else {
      this.setState({instituteId: this.props.authentication.instituteId});
      this.props.fetchFailedUploadsRequest({instituteId: this.props.authentication.instituteId, page: 0, pageSize: 10});
    }
  }

  public render() {
    const { authentication, institutes, fetchFailedUploadsRequest, t } = this.props;

    const selectAll = () => {
      this.setState({selectedPage: "all", instituteId: 0});
      fetchFailedUploadsRequest({instituteId: 0, page: 0, pageSize: 10});
    }
    const selectInstitute = (institute: IInstitute) => {
      this.setState({selectedPage: `institute-${institute.id}`, instituteId: institute.id});
      fetchFailedUploadsRequest({instituteId: institute.id, page: 0, pageSize: 10});
    }

    return (
      <>
        {authentication !==  undefined &&
        <>
          {authentication.sysadmin &&
          <Container fluid={true} className="message-parent-box">
            <Row>
              <Col xs={2} className={"noPaddingRight"}>
                <Nav activeKey={this.state.selectedPage} className="flex-column nav-institute mh-100">
                  <Nav.Link key="all" eventKey="all" onClick={() => selectAll()}>{t("pages.failedUploads.allInstitutes")}</Nav.Link>
                  {institutes && institutes.map((institute) => {
                    return (<Nav.Link key={`institute-${institute.id}`} eventKey={`institute-${institute.id}`} onClick={() => selectInstitute(institute)}>{institute.name}</Nav.Link>);
                  })}
                </Nav>
              </Col>
              <Col xs={10} className={"noPaddingLeft noPaddingRight"}>
                <FailedUploadList instituteId={this.state.instituteId} />
              </Col>
            </Row>
            </Container>
          }
          {!authentication.sysadmin &&
            <>
              <Container fluid={true}>
                <FailedUploadList instituteId={this.state.instituteId} />
              </Container>
            </>
          }
        </>
        }
      </>
    );
  }
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    authentication: store.authentication.authentication,
    institutes: store.institute.data,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  instituteFetchRequest: (includeDeleted: boolean) => dispatch(instituteActions.fetchRequest(includeDeleted)),
  fetchFailedUploadsRequest: (request: IFailedUploadFetchRequest) => dispatch(failedUploadActions.fetchRequest(request)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FailedUploadPage));
